import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=508dbff2&scoped=true&"
import script from "./overlay.vue?vue&type=script&lang=js&"
export * from "./overlay.vue?vue&type=script&lang=js&"
import style0 from "./overlay.vue?vue&type=style&index=0&id=508dbff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dbff2",
  null
  
)

export default component.exports